import { parse } from "date-fns";

import { ICustomField } from "store/entities/custom-fields/interfaces";

export default abstract class CustomFieldSerializer {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserialize(data: { [key: string]: any }): ICustomField {
    const deserialized: ICustomField = {
      id: data.ID,
      licenseID: data.licenseID,
      createdAt: parse(data.createdAt),
      createdBy: data.createdBy,
      createdByType: data.createdByType,
      updatedAt: parse(data.updatedAt),
      updatedBy: data.updatedBy,
      teamIDs: data.teamIDs,
      displayName: data.displayName,
      apiKey: data.apiKey,
      type: data.type,
      roleLevel: data.roleLevel,
      status: data.status,
      tickets: data.tickets,
      ordering: data.ordering,
    };
    return deserialized;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserializeList(list: any): ICustomField[] {
    return list.map(CustomFieldSerializer.deserialize);
  }
}
